module.exports = __webpack_public_path__ + "img/livepen-logo-03.f9f96b83.png";